module.exports = __webpack_public_path__ + "static/media/mail_active.f1258099.svg";